/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import useSWR from 'swr';
import dayjs from 'dayjs';

import Api from '../../../../api';
import CardHeader from '../CardHeader';
import ServiceByService from '../ServiceByService';
import CarrouselDates from '../CarrouseDates';
import ServicesSetup from '../ServicesSetup';
import {
  accentColors,
  mainColors,
  warningColors
} from '../../../../theme/themeConfig';
import ServiceByServiceClientPage from '../ServiceByServiceClientPage';
import useAuthStore from '../../../../store/zustand/auth';
import { TimeFormatEnum } from '../../../../api-client/generated';
import {
  Service,
  ServiceTime,
  Task,
  TaskIteration
} from '../../../../utils/types/ProjectType';
import { convertTo12HourFormat } from '../../../../utils/general';
import { weekDaysIndex } from '../../../../helpers/weekDays';
import { getWorkedTimeAverageTime } from '../../../../utils/calculatorHelper';
import { formatSumTime } from '../../../../utils/calendarHelper';
import CompleteServiceButton from './CompleteServiceButton';

// Función para formatear la cadena de fecha
const formatDateString = (dateString: any) => {
  if (typeof dateString !== 'string') return null;

  const parts = dateString.split('/');
  const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
  return <>{dayjs(formattedDate).format('ddd DD')}</>;
};

function Weekly(props: any) {
  return (
    <Box
      sx={{
        backgroundColor: '#FAFBFC',
        borderTop: '1px solid #E2E4EA',
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
      }}
    >
      {props.days.map(
        (
          index:
            | string
            | {
                date: string;
                status?: {
                  bg: string;
                  bgNormal?: string;
                  txt?: string;
                };
                statusName?: string;
              },
          key: any
        ) => {
          const size = `${100 / props.days.length}%`;
          const isSelected =
            typeof index !== 'string' &&
            index.status &&
            index.date === props.selected;
          const hasDot = typeof index !== 'string' && index.status;
          const cellBg = isSelected
            ? (typeof index !== 'string' && index.status?.bgNormal) || '#E2E4EA'
            : typeof index !== 'string' && index.status
            ? index.status.bg
            : 'transparent';

          return (
            <Box
              key={key}
              minWidth={size}
              onClick={() => {
                if (typeof index !== 'string' && index.status) {
                  props.setDay(index.date);
                }
              }}
              sx={{
                '&:hover':
                  typeof index !== 'string' && index.status
                    ? {
                        backgroundColor: `${
                          (index.status as any).bgNormal || '#E2E4EA'
                        }`
                      }
                    : {},
                backgroundColor: cellBg,
                borderLeft: key !== 0 ? '1px solid #E2E4EA' : 'none',
                boxShadow: isSelected ? 'inset 0 -2px 0 #005DA2' : 'none',
                cursor:
                  typeof index !== 'string' && index.status
                    ? 'pointer'
                    : 'default',
                padding: '8px',
                transition: 'background-color 0.1s',
                width: '100%'
              }}
            >
              {hasDot &&
                typeof index !== 'string' &&
                index.date &&
                index.status && (
                  <Box
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '3px'
                    }}
                  >
                    {/* Status dot */}
                    <Box
                      sx={{
                        backgroundColor: index.status.txt,
                        borderRadius: '50%',
                        height: 6,
                        mx: 'auto',
                        width: 6
                      }}
                    />
                    <Typography
                      align="center"
                      sx={{
                        color: isSelected ? '#0f1c2e' : index.status.txt,
                        fontSize: '11px',
                        fontWeight: isSelected ? 700 : 600,
                        width: '100%'
                      }}
                    >
                      {typeof index.date === 'string' &&
                        formatDateString(index.date)}
                    </Typography>
                  </Box>
                )}
            </Box>
          );
        }
      )}
    </Box>
  );
}

interface Props {
  count: any;
  data: ServiceTime;
  dayChecked: string;
  detailProjectId?: any;
  isOpen: boolean;
  projectName?: string;
  projectType: string;
  setIsOpen: () => void;
  type: string;
  typeView: any;
  utcUpadtedAt: string;
}

const CardContainerServices: React.FC<Props> = function CardContainerServices({
  data,
  count,
  type,
  detailProjectId,
  projectType,
  typeView,
  dayChecked,
  utcUpadtedAt,
  isOpen,
  setIsOpen,
  projectName
}) {
  const [scheduleDateLocal, setScheduleDateLocal] = useState<any>([]);
  const [onlyTask, setOnlyTask] = useState<boolean>(false);
  const [dateRangeId, setDateRangeId] = useState<any>(null);
  const [daysList, setDaysList] = useState<any>([]);
  const [daySelected, setDaySelected] = useState<any>();
  const [calendarState, setCalendarState] = useState<any>(null);
  const [detailInfo, setDetailInfo] = useState<any>({});
  const [daytoSchedule, setDaytoSchedule] = useState<any>(null);
  const userState = useAuthStore((state) => state);
  const location = useLocation();
  const currentUrl = location.pathname;
  const isClientPage = currentUrl.includes('customer-page');

  let generateScheduleAction = Api.ProjectApi.generateSchedule;
  let getDetailByProjectAction = Api.ProjectApi.getDetailByProject;

  if (isClientPage) {
    generateScheduleAction = Api.ClientPageApi.generateSchedule;
    getDetailByProjectAction = Api.ClientPageApi.getDetailByProject;
  }

  const [cardData, seCardData] = useState<any>(null);
  const [taskIterations, setTaskIterations] = useState<any>([]);

  useEffect(() => {
    if (data && (!cardData || cardData.id !== data.id)) {
      seCardData(data);
      // Recorrer los servicios
      const auxTaskIterations: TaskIteration[] = [];

      data.services.forEach((service: Service) => {
        // Recorrer los trabajos (tasks) dentro de cada servicio
        service.tasks.forEach((task: Task) => {
          // Verificar si hay iteraciones de tarea (taskIteration) en este trabajo
          if (task.taskIteration && task.taskIteration.length > 0) {
            // Recorrer las iteraciones de tarea (taskIteration) dentro de cada trabajo
            task.taskIteration.forEach((taskIteration) => {
              // Agregar el objeto taskIteration al array taskIterations
              auxTaskIterations.push(taskIteration);
            });
          }
        });
      });

      if (projectType === 'Ad-Hoc' && !daySelected) {
        const transfDate = dayjs(data.startDate).format('M/D/YYYY');
        const parts = transfDate?.split('/');
        const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
        setDaySelected(formattedDate);
      } else if (typeView === 'calendar' && dayChecked && !daySelected) {
        setDaySelected(dayChecked);
      }

      setTaskIterations(auxTaskIterations);
    }
  }, [data]);

  const parts = dayChecked.split('/');

  const formattedDay = `${parts[1]}/${parts[0]}/${parts[2]}`;
  const dayNotFrequency = dayjs(formattedDay).format('ddd DD');

  const shouldFetchSchedule =
    count > 0 && cardData && detailProjectId && isOpen;
  const {
    data: scheduleData,
    error: scheduleDataError,
    mutate: mutateSchedule
  } = useSWR(
    shouldFetchSchedule
      ? [
          cardData?.startDate,
          cardData?.endDate,
          cardData?.frequency,
          cardData?.frequencyWeek,
          cardData?.frequencyDays,
          detailProjectId,
          cardData.id
        ]
      : null,
    generateScheduleAction
  );

  useEffect(() => {
    if (scheduleData && !scheduleDataError) {
      setScheduleDateLocal(scheduleData);
    }
  }, [scheduleData, scheduleDataError]);

  let timePart = '';

  if (typeView === 'calendar') {
    const localDate = dayjs.utc(utcUpadtedAt).local();
    const utcUpadtedCalendar = localDate.format('YYYY-MM-DD HH:mm:ss.SSS');
    // eslint-disable-next-line no-unsafe-optional-chaining
    const timePartInner = utcUpadtedCalendar?.split(' ');
    timePart = timePartInner[1] || '00:00:00';
  }

  const shouldFetchDetail =
    daytoSchedule !== null && detailProjectId && cardData;

  const {
    data: detailServicesData,
    error: detailServicesDataError,
    mutate: mutateDetail
  } = useSWR(
    shouldFetchDetail
      ? [
          detailProjectId,
          cardData.id,
          daytoSchedule,
          projectType === 'Ad-Hoc' ? data.startTime : timePart,
          daytoSchedule,
          userState?.timeFormat
        ]
      : null,
    getDetailByProjectAction
  );

  useEffect(() => {
    if (detailServicesData && !detailServicesDataError) {
      setDetailInfo(detailServicesData);
      setCalendarState(detailServicesData?.state);
    } else {
      setOnlyTask(true);
    }
  }, [detailServicesData, detailServicesDataError, daySelected, onlyTask]);

  useEffect(() => {
    if (dateRangeId) {
      const daysId = scheduleDateLocal.find(
        (obj: any) => obj.id === dateRangeId
      )?.id;
      if (daysId) {
        const res = scheduleDateLocal.find((d: any) => d.id === daysId);
        if (res) {
          const colorsByStatus = {
            Completed: {
              bg: accentColors.ACCENT_6,
              bgNormal: accentColors.ACCENT_1,
              txt: accentColors.ACCENT
            },
            Created: {
              bg: mainColors.MAIN_LIGHT,
              bgNormal: mainColors.MAIN_1,
              txt: mainColors.MAIN_4
            },
            Started: {
              bg: warningColors.LIGHT_ERROR,
              bgNormal: warningColors.ERROR_1,
              txt: warningColors.ERROR
            }
          };

          const daysWithStatus = res.stateDatesList.map((day: any) => {
            let statusColors;
            switch (day?.state) {
              case 'Completed':
                statusColors = colorsByStatus.Completed;
                break;
              case 'InProgress':
              case 'Started':
                statusColors = colorsByStatus.Started;
                break;
              case 'Awaiting':
              case 'Created':
                statusColors = colorsByStatus.Created;
                break;
              default:
                statusColors = colorsByStatus.Created;
                break;
            }
            return {
              date: day.formatted,
              status: statusColors,
              statusName: day?.state
            };
          });
          setDaysList(daysWithStatus);
        }
      }
    }
  }, [dateRangeId, scheduleDateLocal, detailInfo]);

  useEffect(() => {
    if (daySelected && (!daytoSchedule || daySelected !== daytoSchedule)) {
      setDaytoSchedule(daySelected);
    }
  }, [daySelected]);

  useEffect(() => {
    if (dayChecked && scheduleDateLocal) {
      const matchingDate = scheduleDateLocal.find((date: any) =>
        date.days.includes(dayChecked)
      );
      if (matchingDate) {
        setDateRangeId(matchingDate.id);
      } else {
        const parts = dayChecked.split('/');
        // eslint-disable-next-line radix
        const formattedDay = `${parseInt(parts[1])}/${parseInt(parts[0])}/${
          parts[2]
        }`;
        scheduleDateLocal.some((date: any) => {
          // Usa Array.some() para detener la búsqueda al encontrar la coincidencia
          const [start, end] = date.range.split(' - ');
          if (formattedDay >= start && formattedDay <= end) {
            setDateRangeId(date?.id);
            return true; // Detiene la iteración
          }
          return false; // Continúa la iteración
        });
      }
    }
  }, [dayChecked, scheduleDateLocal]);

  const uniqueTechnicians = detailInfo?.assignments
    ?.map((item: any) => item?.technician)
    ?.filter(
      (technician: any, index: number, self: any) =>
        self.findIndex((t: any) => t?.id === technician?.id) === index
    );

  const uniqueTechniciansWithEvents = uniqueTechnicians?.map(
    (technician: any) => {
      // Find the corresponding calendar event iteration for this technician
      const calendarEventIteration = detailInfo?.calendarEventIterations?.find(
        (event: any) => event?.technician?.id === technician?.id
      );

      // Return the technician with the added calendar event iteration if found
      return {
        ...technician,
        calendarEventIteration: calendarEventIteration || null
      };
    }
  );

  const tasksAmount =
    detailInfo?.serviceTime?.services?.reduce(
      (count: number, service: Service) => {
        return count + (service?.tasks?.length || 0);
      },
      0
    ) || 0;

  const mutate = () => {
    mutateSchedule(undefined, { revalidate: true });
    mutateDetail(undefined, { revalidate: true });
  };

  // ── Schedule info ──────────────────────────────────────────────────────
  const scheduleString = (() => {
    const days = data?.frequencyDays || [];
    const sorted = [...days].sort(
      (a: string, b: string) =>
        (weekDaysIndex[a] ?? 7) - (weekDaysIndex[b] ?? 7)
    );
    const daysStr =
      sorted.length > 1
        ? `${sorted[0].slice(0, 3)}-${sorted[sorted.length - 1].slice(0, 3)}`
        : sorted[0]?.slice(0, 3) || '';
    if (!data?.startTime || !data?.endTime) return daysStr;
    try {
      const fmt =
        userState?.timeFormat === 'twentyFourHours' ? 'HH:mm' : 'h:mm A';
      const [sh, sm] = (data.startTime as string).split(':').map(Number);
      const [eh, em] = (data.endTime as string).split(':').map(Number);
      const startFmt = dayjs().hour(sh).minute(sm).format(fmt);
      const endFmt = dayjs().hour(eh).minute(em).format(fmt);
      return `${daysStr} · ${startFmt} – ${endFmt}`;
    } catch {
      return daysStr;
    }
  })();

  const { totalEstMinutes, totalWorkedMinutes } = (() => {
    const services = detailInfo?.serviceTime?.services || data?.services || [];
    let est = 0;
    let worked = 0;
    services.forEach((svc: Service) => {
      svc.tasks?.forEach((task: Task) => {
        const perTech = (task as any)?.totalTimeInHours
          ? (task as any).totalTimeInHours /
            (task.technicians?.length || (task as any).minimumResources || 1)
          : 0;
        est += perTech;
        if ((task as any).taskIteration?.length > 0)
          worked += getWorkedTimeAverageTime((task as any).taskIteration);
      });
    });
    return { totalEstMinutes: est * 60, totalWorkedMinutes: worked };
  })();

  const showingDate = daySelected
    ? (() => {
        const parts = daySelected.split('/');
        return dayjs(`${parts[1]}/${parts[0]}/${parts[2]}`).format(
          'dddd, MMM D, YYYY'
        );
      })()
    : '';

  const stateColors: Record<
    string,
    { bg: string; dot: string; label: string }
  > = {
    Awaiting: { bg: '#F5F6F8', dot: '#7D8090', label: 'Awaiting' },
    Completed: { bg: '#E8F8F2', dot: '#189A90', label: 'Completed' },
    Created: { bg: '#FFF4E5', dot: '#E79137', label: 'In Progress' },
    InProgress: { bg: '#FFF4E5', dot: '#E79137', label: 'In Progress' }
  };
  const cardState =
    stateColors[detailInfo?.state || 'Awaiting'] || stateColors.Awaiting;

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <Box
      sx={{
        '&:hover': { borderColor: '#A2CDEC' },
        backgroundColor: 'white',
        border: '1px solid #E2E4EA',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'border-color 0.15s',
        width: '100%'
      }}
    >
      {projectType === 'Regular' && (
        <Box
          onClick={setIsOpen}
          sx={{
            '&:hover': { backgroundColor: '#F5F6F8' },
            alignItems: 'flex-start',
            backgroundColor: '#FAFBFC',
            borderBottom: isOpen ? '1px solid #E2E4EA' : 'none',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 16px'
          }}
        >
          {/* Top row: title + schedule + status + Complete Visit + collapse */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1.5
              }}
            >
              <Typography
                sx={{ color: '#0f1c2e', fontSize: '13px', fontWeight: 700 }}
              >
                {`Service Time #${count}`}
              </Typography>
              {scheduleString && (
                <Typography sx={{ color: '#7D8090', fontSize: '12px' }}>
                  · {scheduleString}
                </Typography>
              )}
              {detailInfo?.state && (
                <Box
                  sx={{
                    alignItems: 'center',
                    backgroundColor: cardState.bg,
                    borderRadius: '20px',
                    display: 'flex',
                    gap: '5px',
                    px: '8px',
                    py: '3px'
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: cardState.dot,
                      borderRadius: '50%',
                      height: 7,
                      width: 7
                    }}
                  />
                  <Typography
                    sx={{
                      color: cardState.dot,
                      fontSize: '11px',
                      fontWeight: 600
                    }}
                  >
                    {cardState.label}
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{ alignItems: 'center', display: 'flex', gap: 1 }}
            >
              {projectName && (
                <CompleteServiceButton
                  calendarEventId={detailInfo?.id}
                  daySelected={daySelected}
                  modalDescription="Are you sure you want to complete this visit?"
                  modalTitle="Complete Visit"
                  mutate={mutate}
                  projectName={projectName}
                  state={detailInfo?.state}
                  tasksAmount={tasksAmount}
                  technicians={uniqueTechniciansWithEvents}
                />
              )}
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen();
                }}
                sx={{
                  alignItems: 'center',
                  border: '1px solid #E2E4EA',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  display: 'flex',
                  height: 28,
                  justifyContent: 'center',
                  width: 28
                }}
              >
                <i
                  className={`custom-icon icon-chevron-${
                    isOpen ? 'up' : 'down'
                  }`}
                  style={{ color: '#7D8090', fontSize: 12 }}
                />
              </Box>
            </Box>
          </Box>
          {/* Summary row: Est. + Worked */}
          {(totalEstMinutes > 0 || totalWorkedMinutes > 0) && (
            <Box
              sx={{ alignItems: 'center', display: 'flex', gap: 2, mt: '4px' }}
            >
              <Box sx={{ alignItems: 'center', display: 'flex', gap: '5px' }}>
                <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
                  Est. time:
                </Typography>
                <Typography
                  sx={{ color: '#0f1c2e', fontSize: '12px', fontWeight: 600 }}
                >
                  {formatSumTime(totalEstMinutes)}
                </Typography>
              </Box>
              {totalWorkedMinutes > 0 && (
                <Box sx={{ alignItems: 'center', display: 'flex', gap: '5px' }}>
                  <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
                    Worked:
                  </Typography>
                  <Typography
                    sx={{ color: '#189A90', fontSize: '12px', fontWeight: 700 }}
                  >
                    {formatSumTime(totalWorkedMinutes)}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}

      {isOpen && projectType === 'Regular' && (
        <Box>
          {type === 'serviceTime' && (
            <CarrouselDates
              dates={scheduleDateLocal}
              selected={dateRangeId}
              setDay={setDaySelected}
              setDetailInfo={setDetailInfo}
              setSelectedDayIndex={setDateRangeId}
            />
          )}
          {type === 'serviceTime' && dateRangeId !== null ? (
            <Weekly
              calendarState={detailInfo.state}
              days={daysList}
              selected={daySelected}
              setDay={setDaySelected}
              setDetailInfo={setDetailInfo}
            />
          ) : (
            dateRangeId === null &&
            type === 'serviceTime' && (
              <Box
                sx={{
                  alignItems: 'center',
                  backgroundColor: '#FEF6E7',
                  border: '1px solid #F5D3AF',
                  borderRadius: '6px',
                  display: 'flex',
                  gap: '6px',
                  mx: 2,
                  my: 1,
                  px: 2,
                  py: '8px'
                }}
              >
                <i
                  className="custom-icon icon-warning"
                  style={{ color: '#E79137', fontSize: 13 }}
                />
                <Typography color="#E79137" fontSize={11} variant="secondary">
                  {`${dayNotFrequency} is not in the configured service frequency`}
                </Typography>
              </Box>
            )
          )}

          {/* Legend bar */}
          {type === 'serviceTime' && showingDate && (
            <Box
              sx={{
                alignItems: 'center',
                borderTop: '1px solid #E2E4EA',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '14px',
                px: 2,
                py: '8px'
              }}
            >
              <Typography sx={{ color: '#4B4D56', fontSize: '12px' }}>
                Showing: <strong>{showingDate}</strong>
              </Typography>
              {[
                { dot: '#189A90', label: 'Completed' },
                { dot: '#E79137', label: 'In Progress / Created' },
                { dot: '#7D8090', label: 'Awaiting' }
              ].map(({ dot, label }) => (
                <Box
                  key={label}
                  sx={{ alignItems: 'center', display: 'flex', gap: '5px' }}
                >
                  <Box
                    sx={{
                      backgroundColor: dot,
                      borderRadius: '50%',
                      height: 7,
                      width: 7
                    }}
                  />
                  <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
                    {label}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}

          {type === 'serviceSetup' && <ServicesSetup data={data} />}

          {type === 'serviceSetup' &&
            data?.services?.map((service) => (
              <React.Fragment key={service.id}>
                {isClientPage ? (
                  <ServiceByServiceClientPage
                    detailInfo={data}
                    detailProjectId={detailProjectId}
                    key={service.id}
                    mutateAction={mutate}
                    onlyTask={false}
                    projectType=""
                    service={service}
                    servicesInfo={detailInfo?.serviceTime}
                    setOnlyTask={setOnlyTask}
                    type="serviceSetup"
                    typeView=""
                  />
                ) : (
                  <ServiceByService
                    detailInfo={data}
                    detailProjectId={detailProjectId}
                    key={service.id}
                    mutateAction={mutate}
                    onlyTask={false}
                    projectType=""
                    service={service}
                    servicesInfo={detailInfo?.serviceTime}
                    setOnlyTask={setOnlyTask}
                    type="serviceSetup"
                    typeView=""
                  />
                )}
              </React.Fragment>
            ))}

          {type === 'serviceTime' &&
            dateRangeId !== null &&
            detailInfo &&
            daySelected && (
              <>
                {detailInfo.serviceTime
                  ? detailInfo.serviceTime.services.map((service: Service) => {
                      return (
                        <React.Fragment key={service.id}>
                          {isClientPage ? (
                            <ServiceByServiceClientPage
                              calendarEvenState={detailInfo.state}
                              detailInfo={{
                                timezone: data?.timezone || null
                              }}
                              detailProjectId={[]}
                              key={service.id}
                              mutateAction={mutate}
                              onlyTask={false}
                              projectType={projectType}
                              service={service}
                              servicesInfo={detailInfo?.serviceTime}
                              setOnlyTask={setOnlyTask}
                              type="serviceTime"
                              typeView={typeView}
                            />
                          ) : (
                            <ServiceByService
                              calendarEvenState={detailInfo.state}
                              detailInfo={{
                                timezone: data?.timezone || null
                              }}
                              detailProjectId={[]}
                              key={service.id}
                              mutateAction={mutate}
                              onlyTask={false}
                              projectType={projectType}
                              service={service}
                              servicesInfo={detailInfo?.serviceTime}
                              setOnlyTask={setOnlyTask}
                              type="serviceTime"
                              typeView={typeView}
                            />
                          )}
                        </React.Fragment>
                      );
                    })
                  : data.services.map((service) => {
                      return (
                        <React.Fragment key={service.id}>
                          {isClientPage ? (
                            <ServiceByServiceClientPage
                              calendarEvenState={detailInfo.state}
                              detailInfo={detailInfo}
                              detailProjectId={detailProjectId}
                              key={service.id}
                              mutateAction={mutate}
                              onlyTask={onlyTask}
                              projectType={projectType}
                              service={service}
                              servicesInfo={data}
                              setOnlyTask={setOnlyTask}
                              type="serviceTime"
                              typeView={typeView}
                            />
                          ) : (
                            <ServiceByService
                              calendarEvenState={detailInfo.state}
                              detailInfo={detailInfo}
                              detailProjectId={detailProjectId}
                              key={service.id}
                              mutateAction={mutate}
                              onlyTask={onlyTask}
                              projectType={projectType}
                              service={service}
                              servicesInfo={data}
                              setOnlyTask={setOnlyTask}
                              type="serviceTime"
                              typeView={typeView}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
              </>
            )}
        </Box>
      )}
      {projectType === 'Ad-Hoc' && (
        <Box>
          {detailInfo.serviceTime &&
          detailInfo.serviceTime.services &&
          detailInfo.serviceTime.services.length > 0
            ? detailInfo.serviceTime.services.map((service: Service) => (
                <React.Fragment key={service.id}>
                  {isClientPage ? (
                    <ServiceByServiceClientPage
                      detailInfo={{}}
                      detailProjectId={[]}
                      key={service.id}
                      mutateAction={mutate}
                      onlyTask={false}
                      projectType={projectType}
                      service={service}
                      servicesInfo={detailInfo.serviceTime}
                      setOnlyTask={setOnlyTask}
                      type="serviceTime"
                      typeView={typeView}
                    />
                  ) : (
                    <ServiceByService
                      detailInfo={{}}
                      detailProjectId={[]}
                      key={service.id}
                      mutateAction={mutate}
                      onlyTask={false}
                      projectType={projectType}
                      service={service}
                      servicesInfo={detailInfo.serviceTime}
                      setOnlyTask={setOnlyTask}
                      type="serviceTime"
                      typeView={typeView}
                    />
                  )}
                </React.Fragment>
              ))
            : data.services.map((service: Service) => (
                <React.Fragment key={service.id}>
                  {isClientPage ? (
                    <ServiceByServiceClientPage
                      calendarEvenState={detailInfo.state}
                      detailInfo={detailInfo}
                      detailProjectId={detailProjectId}
                      key={service.id}
                      mutateAction={mutate}
                      onlyTask={onlyTask}
                      projectType={projectType}
                      service={service}
                      servicesInfo={detailInfo?.serviceTime}
                      setOnlyTask={setOnlyTask}
                      type="serviceTime"
                      typeView={typeView}
                    />
                  ) : (
                    <ServiceByService
                      calendarEvenState={detailInfo.state}
                      detailInfo={detailInfo}
                      detailProjectId={detailProjectId}
                      key={service.id}
                      mutateAction={mutate}
                      onlyTask={onlyTask}
                      projectType={projectType}
                      service={service}
                      servicesInfo={data}
                      setOnlyTask={setOnlyTask}
                      type="serviceTime"
                      typeView={typeView}
                    />
                  )}
                </React.Fragment>
              ))}
        </Box>
      )}
      {/* Footer hint */}
      {type === 'serviceTime' && (
        <Box
          sx={{
            alignItems: 'center',
            borderTop: '1px solid #F0F1F3',
            display: 'flex',
            gap: '6px',
            px: 2,
            py: '8px'
          }}
        >
          <i
            className="custom-icon icon-info"
            style={{ color: '#7D8090', fontSize: 13 }}
          />
          <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
            Click any task row with a status to open the task detail modal
            (technician check-in/out, photos, notes, worked time)
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default CardContainerServices;
CardContainerServices.defaultProps = {
  detailProjectId: undefined
};
